import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=89ed2c8a&"
import script from "./side-menu.vue?vue&type=script&lang=js&"
export * from "./side-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('89ed2c8a', component.options)
    } else {
      api.reload('89ed2c8a', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=89ed2c8a&", function () {
      api.rerender('89ed2c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/layout/side-menu.vue"
export default component.exports